/**
 * Retry Premium Video Payment UseCase
 *
 * Retries the failed premium-video (upload) payment for a content item.
 * Mirrors Flutter MediasRepository.retryPremiumVideoPayment →
 * CloudFunctionsService.retryPremiumVideoPayment
 * (lib/data/repository/medias_repository.dart:389-391).
 *
 * The returned boolean is load-bearing: the caller branches a "Done" vs
 * "There was an error. Please try again!" toast on it
 * (lib/services/push_navigation_service.dart:515-530).
 */

import { MediaService } from '@/domain/services/media/mediaService';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class RetryPremiumVideoPaymentUseCase {
  private mediaService: MediaService;

  constructor(mediaService?: MediaService) {
    this.mediaService = mediaService || new MediaService();
  }

  async execute(contentId: string): Promise<boolean> {
    try {
      return await this.mediaService.retryPremiumVideoPayment(contentId);
    } catch (error) {
      appLogger.error('Error retrying premium video payment', 'RetryPremiumVideoPaymentUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const retryPremiumVideoPaymentUseCase = new RetryPremiumVideoPaymentUseCase();
